export default "__VITE_ASSET__eb95d2e2__"